import classNames from 'classnames';
export function getButtonVariant(variant) {
    const { baseStyles, hoverStyles } = BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.default;
    const variantClasses = classNames(baseStyles, hoverStyles);
    return variantClasses;
}
const DEFAULT_CLASSES = 'text-white flex rounded py-2 px-4 focus::outline-none focus:shadow-outline';
const BUTTON_VARIANTS = {
    cancel: {
        baseStyles: 'bg-accent text-white border border-red-600 p-2 px-6 justify-center',
        hoverStyles: 'hover:bg-white hover:text-accent'
    },
    confirm: {
        baseStyles: 'bg-primary p-2 px-6 justify-center',
        hoverStyles: 'hover:bg-accent'
    },
    default: {
        baseStyles: DEFAULT_CLASSES,
        hoverStyles: ''
    }
};
